import React from "react";
import "../styles.css";

class TutorialWCAG extends React.Component{
  constructor(props) {
    super(props);
    this.state = {};
    this.focusRef = React.createRef();
  }

  //componentDidMount will place the focus of the user (for screen reader purposes) on the first element on the page.
  async componentDidMount() {
    if (this.focusRef.current) {
      this.focusRef.current.focus();
    }
  }

  //render the following content on the page (buttons, videos, and text guides).
  //render will show the tutorial video for the WCAG Reasons along with helpful text describing that page's elements.
  render() {
      return (
        <div className="flex-width-paragraph" style={{paddingTop:"20px"}}>
            <h2 className="centered-VersionText" autoFocus={true} ref={this.focusRef} tabIndex="0" id="focus">WCAG Reasons Tutorial Page</h2>
            <h3 className="bold-text-video" tabIndex="0">WCAG Reasons Video Tutorial</h3>
            <video controls
              src="https://isenpai-act-portal-tutorials.s3.amazonaws.com/WCAG.mp4"
              width="765"
              height="515">
              Sorry, your browser doesn't support embedded videos.
            </video>
            <p className="bold-text">WCAG Reasons Text Tutorial</p>
            <ul className="list-text">
              <li>WCAG stands for web content accessibility guidelines</li>
              <li>The user must navigate to a results page which can be done by clicking the search buttong on the homepage.</li>
              <li>Once on the results page, the user can click on the link in the accessibility grade column for any entry.</li>
              <li>After being redirected, there will be information listed about that specific website on a new page:</li>
                <ul>
                  <li>Date of last test</li>
                  <li>WCAG grade that the website received</li>
                  <li>A table displaying the elements missing that deduct points</li>
                </ul>
              <li>The user can sort the table (title, criteria, wcag level, and severity).</li>
              <li>WCAG level is from A to AAA and severity ranges from moderate to serious to critical.</li>
              <li>There is also a leave a review button in the top-right that navigates the user to the review portion of the page.</li>
            </ul>
        </div>
      )
  }
}

export default TutorialWCAG;
